module.exports = __webpack_public_path__ + "img/Girl_020013.947e485c.png";